/* ======================  SCRIPTS ====================== */

    $('document').ready(smoothScroll);

    function smoothScroll() {

        /************  GESTION DU SCROLL SMOOTH *****************/

        $(document).on('click', '.gammes-onecard', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1500);
        });

        /************  GESTION DU FADE IN *****************/

        /* Every time the window is scrolled ... */
        $(window).scroll( function(){

            /* Check the location of each desired element */
            $('.fade').each( function(i){

                var bottom_of_object = $(this).position().top + $(this).outerHeight(true);
                var bottom_of_window = $(window).scrollTop() + $(window).height();

                /* If the object is visible in the window, fade it it */

                if(window.matchMedia("(min-width: 1200px)").matches) {
                    if (bottom_of_window > bottom_of_object - 500) {
                        $(this).animate({'opacity': '1'}, 900);
                    }
                } else if (window.matchMedia("(min-width: 1000px)").matches) {
                    if (bottom_of_window > bottom_of_object - 500) {
                        $(this).animate({'opacity': '1'}, 900);
                    }
                } else if (window.matchMedia("(min-width: 760px)").matches) {
                    if (bottom_of_window > bottom_of_object - 300) {
                        $(this).animate({'opacity': '1'}, 900);
                    }
                } else if (window.matchMedia("(min-width: 576px)").matches) {
                    if (bottom_of_window > bottom_of_object) {
                        $(this).animate({'opacity': '1'}, 900);
                    }
                }
            });
        });

        /************  GESTION DU BACK TO TOP *****************/

        var $backToTop = $(".back-to-top");
        $backToTop.hide();


        $(window).on('scroll', function() {
            if ($(this).scrollTop() > 600) {
                $backToTop.fadeIn();
            } else {
                $backToTop.fadeOut();
            }
        });

        $backToTop.on('click', function(e) {
            $("html, body").animate({scrollTop: 0}, 500);
        });
    }